// extracted by mini-css-extract-plugin
export default {"modal_body_height":"style_modal_body_height__6Coj5","modal_body_withOutScroll":"style_modal_body_withOutScroll__oVHrC"};